import config from '../../config'
import { IAxiosSuccess } from '../interface'
import server from '../axiosInstance'
import { ContentType } from '../header'
import { cryptRAS, filterDataEmpty, getSignedData, getTimestamp, randomNum } from '../utils'
import { ReportCustomDataType, ReportDataType } from '../types/sls'

const { slsURL, baseSecret, beginPublicKey } = config
/**
 * sls上报打点
 * @returns
 * @api
 */
export const postSLSReportData = (events: { eventName: string, customData: ReportCustomDataType }[]): Promise<IAxiosSuccess<Record<string, unknown>>> => {
  const mktRegionMap: Record<string, string> = {
    development: 'sea',
    stable: 'sea',
    stableMe: 'me',
    stableSa: 'sa',
    production: 'sea',
    productionMe: 'me',
    productionSa: 'sa'
  }
  const reportDataArray: ReportDataType[] = events.map(event => ({
    data_ver: 1, // 数据上报格式版本号
    page_type: 'page_out_app', // 网页业务类型，page_out_app=端外网页
    mkt_region: mktRegionMap[process.env.VUE_APP_ENV || 'development'], // 市场大区，sea：东南亚，me：中东
    url: window.location.href, // 当前网页url地址
    event_name: event.eventName,
    data: { ...event.customData } // 自定义数据
  }))
  console.log('sls', reportDataArray)
  const encryptLogs = cryptRAS.encrypt(JSON.stringify(reportDataArray), beginPublicKey)
  const data = {
    logs: encryptLogs,
    sign: '',
    appId: 1004,
    timestamp: getTimestamp(),
    random: randomNum(6)
  }

  data.sign = getSignedData(data, baseSecret, false)
  filterDataEmpty(data)
  const env = process.env.VUE_APP_ENV || 'development'
  const pathMap: any = {
    stable: '/v1/logCapture/stable/submit',
    stableMe: '/v1/logCapture/stable-me/submit',
    stableSa: '/v1/logCapture/stable-sa/submit',
    production: '/v1/logCapture/submit',
    productionMe: '/v1/logCapture/submit',
    productionSa: '/v1/logCapture/submit',
    development: '/v1/logCapture/submit'
  }
  const path = pathMap[env]
  return server.request<null, IAxiosSuccess<Record<string, unknown>>>({
    url: `${slsURL}${path}`,
    method: 'POST',
    headers: {
      'Content-Type': ContentType.JSON
    },
    data
  })
}
